import React from 'react';
import { styled } from 'styled-components';
const TypingIndicator = (props) => {
    return (React.createElement(StyledTypingIndicator, { writing: props.writing },
        React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("span", null),
                React.createElement("span", null),
                React.createElement("span", null)))));
};
export default TypingIndicator;
const StyledTypingIndicator = styled.div `
  overflow: hidden;

  & > div {
    background-color: #e6e7ec;
    width: 40px;
    line-height: 24px;
    display: block;
    border-radius: 30% / 50%;
    transform: ${(props) => props.writing ? 'translateY(0%)' : 'translateY(100%)'};
    transition: transform 0.2s;

    & > div {
      text-align: center;

      & > span {
        display: inline-block;
        background-color: #b6b5ba;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        margin-right: 2px;
        animation: bob 2s infinite;

        &:nth-child(1) {
          animation-delay: -1s;
        }
        &:nth-child(2) {
          animation-delay: -0.85s;
        }
        &:nth-child(3) {
          animation-delay: -0.7s;
          margin-right: 0;
        }
      }
    }
  }

  @keyframes bob {
    10% {
      transform: translateY(-10px);
      background-color: #9e9da2;
    }
    50% {
      transform: translateY(0);
      background-color: #b6b5ba;
    }
  }
`;
//# sourceMappingURL=TypingIndicator.js.map